import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortfolioMilestones = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "tour",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2647_1295",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 20,
				height: 20,
				fill: "var(--fill-0, #D9D9D9)"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2647_1295)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "tour_2",
				d: "M4.375 18.125V1.875H5.625V3.54167H17.1954L15.609 7.5L17.1954 11.4583H5.625V18.125H4.375ZM11.4496 8.53292C11.7332 8.24917 11.875 7.90486 11.875 7.5C11.875 7.09514 11.7332 6.75083 11.4496 6.46708C11.1658 6.18347 10.8215 6.04167 10.4167 6.04167C10.0118 6.04167 9.6675 6.18347 9.38375 6.46708C9.10014 6.75083 8.95833 7.09514 8.95833 7.5C8.95833 7.90486 9.10014 8.24917 9.38375 8.53292C9.6675 8.81653 10.0118 8.95833 10.4167 8.95833C10.8215 8.95833 11.1658 8.81653 11.4496 8.53292ZM5.625 10.2083H15.3463L14.266 7.5L15.3463 4.79167H5.625V10.2083Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgPortfolioMilestones;
